import { render, staticRenderFns } from "./EditarVentaDialog.vue?vue&type=template&id=2c5f4e25"
import script from "./EditarVentaDialog.vue?vue&type=script&lang=js"
export * from "./EditarVentaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports